module.exports = __webpack_public_path__ + "img/silueta.1d1bb726.png";